'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>' + '<svg width="7px" height="11px" viewBox="0 0 7 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + '<path d="M3.5,0 L7,4 L0,4 L3.5,0 Z M3.5,11 L7,7 L0,7 L3.5,11 Z" />' + '</svg>';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/elemental-react16/lib/icons/selectArrows.js
// module id = 936
// module chunks = 0